import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModelModule } from '@netfoundry-ui/shared/model';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NetworkControllerRegistrationComponent } from './network-controller-registration.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModelModule,
        MatTooltipModule
    ],
    declarations: [NetworkControllerRegistrationComponent],
    exports: [NetworkControllerRegistrationComponent],
})
export class FeatureNetworkControllerRegistrationModule {}
